import { Badge, Text } from '@/design-system/components/ui';

interface Props {
  value: string;
  suffix?: string;
}

export function ArgumentDisplay({ value, suffix = 'parameter' }: Props) {
  return (
    <div className="tw:flex tw:flex-row tw:gap-1">
      <Badge variant="outline" size="sm">
        {value}
      </Badge>
      <Text as="span" variant="body-sm">
        {suffix}
      </Text>
    </div>
  );
}
